// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nx-0";